const colorTypes = {
    normal:`#A8A878`,
    psychic:`#F85888`,
    fire:`#F08030`,
    bug:`#A8B820`,
    water:`#6890F0`,
    rock:`#B8A038`,
    electric:`#F8D030`,
    ghost:`#705898`,
    grass:`#78C850`,
    dragon:`#7038F8`,
    ice:`#98D8D8`,
    dark:`#705848`,
    fighting:`#C03028`,
    steel:`#B8B8D0`,
    poison:`#A040A0`,
    fairy:`#EE99AC`,
    ground:`#E0C068`,
    unknown:`#68A090`,
    flying:`#A890F0`,
    shadow:`#6711B2`
}

export default colorTypes